import React, { Component } from "react";
// import logo from "./assets/images/logo.png";
import live from "./assets/images/live.png";
import logomr from "./assets/images/logomr.png";
import cartImg from "./assets/home_icons/Home Page_website-02.png";
import { ToastContainer, toast } from "react-toastify";
import {
  Route,
  Link,
  BrowserRouter as Router,
  Redirect,
  withRouter
} from "react-router-dom";
import "./assets/dist/css/bootstrap.css";
import "./assets/css/style.css";
import "./assets/css/rfs.css";
import * as myConstClass from "./constant.js";
import userCircleIcon from "./assets/icons/user-circle.svg";
import { getProductCartCount, getCartDisplayCount } from "./constant.js";
import { updateGuestCartDisplay } from './utils/guestCartHelpers';
import { clearGuestStatesOnLogin } from './utils/guestStateManager';
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { stateToHTML } from "draft-js-export-html";
import $ from "jquery";
import Appnew from "./Appnew.js";
import Header from "./Header";
import ReactGA from "react-ga";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import {
  setTranslations,
  setDefaultLanguage,
  setLanguageCookie,
  setLanguage,
  translate,
} from "react-switch-lang";
import en from "./en.json";
import ma from "./ma.json";
import PropTypes from "prop-types";
import SimpleReactValidator from "simple-react-validator";
import { routes } from "./routes.constants";
import "./newHeader.css";
import { ProgressBarProvider as ProgressBar } from 'react-redux-progress';
import { ProgressBarProvider } from 'react-redux-progress/ProgressBarProvider';

setTranslations({ en, ma });
setDefaultLanguage("en");
setLanguageCookie();

class NewHeader extends Component {
    // Close all dropdowns
    closeAllDropdowns = () => {
      this.setState({
        openAboutMenu: false,
        openEventsMenu: false,
        openProductsMenu: false,
        openResourcesMenu: false,
        openMyAccountMenu: false,
      });
    }
  constructor(props) {
    super(props);
    this.someTrackingHandler = this.someTrackingHandler.bind(this);
    ReactGA.initialize("UA-21334372-1");
    ReactGA.pageview(window.location.pathname + window.location.search);

    const initialCartCount = typeof window !== 'undefined'
      ? (localStorage.getItem('cached_cart_count') || localStorage.getItem('cartCount') || '0')
      : '0';

    this.state = {
      subscribeinfo: {
        first_name: "",
        last_name: "",
        message: "",
        status: "",
        email: "",
      },
      user_id: "",
      redirect: false,
      userinfo: {
        first_name: "",
        middle_name: "",
        last_name: "",
        profile_picture: "profile.jpg",
      },
      settinginfo: {
        url: "",
        on_off: "",
      },
      menuinfo: "",
      diwaliissueinfo: {
        status: "",
        message: "",
        magazine_id: "",
        issue_id: "",
      },
      cartcount: {
        totalcartcount: initialCartCount,
      },
      subMenuLevel1: false,
      subMenuLevel1Heading: "",
      subMenuLevel1List: [],
      subMenuLevel2Heading: "",
      subMenuLevel2: false,
      subMenuLevel2List: [],
      eventList: [],
      mobileMenuOpen: false,
      showTopicsDropdown: false,
      showEventsDropdown: false,
      showShopDropdown: false,
      showResourcesDropdown: false,
      isMobile: false,
      openAboutMenu: false,
      openEventsMenu: false,
      openProductsMenu: false,
      openResourcesMenu: false,
      openMyAccountMenu: false,
      openMachineTestsMenu: false,
      openProfileMenu: false,
      openProductTypes: {},
      openEventTypes: {},
      openTopics: {},
      loading: false
    };
    this.key = "en";

    this.logout = this.logout.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validatorNewsletter = new SimpleReactValidator();
    this.handleSetLanguageNew = this.handleSetLanguageNew.bind(this);
    this.getEvent = this.getEvent.bind(this);
    this.getEvent();
    this.handleCartClick = this.handleCartClick.bind(this);
  }

  componentDidMount() {
    // Initialize language from localStorage
    var key = localStorage.getItem("key");
    if (key) {
      this.key = key;
      setLanguage(key);
      setLanguageCookie("lang_key");
    } else {
      // Default to English if not set
      this.key = "en";
      localStorage.setItem("key", "en");
      setLanguage("en");
      setLanguageCookie("lang_key");
    }

    // use a media query so the JS detection matches CSS breakpoints exactly
    this.mediaQuery = window.matchMedia("(max-width: 768px)");
    const mqHandler = (e) => this.setState({ isMobile: e.matches });
    // set initial value
    this.setState({ isMobile: this.mediaQuery.matches });
    // attach listener (use addEventListener where supported)
    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener("change", mqHandler);
      this._mqHandler = mqHandler;
    } else if (this.mediaQuery.addListener) {
      this.mediaQuery.addListener(mqHandler);
      this._mqHandler = mqHandler;
    }
    // this.getsiteinfo();
    this.getUserInfo();
    this.getProductCartCount();
    //this.checkDiwaliIssue();
    this.checkUserLogin();

    document.addEventListener('mousedown', this.handleClickOutside);
    this.setState({ loading: true });

    setTimeout(() => {
      this.setState({ loading: false });
    }, 3000);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    if (this.mediaQuery) {
      if (this.mediaQuery.removeEventListener && this._mqHandler) {
        this.mediaQuery.removeEventListener("change", this._mqHandler);
      } else if (this.mediaQuery.removeListener && this._mqHandler) {
        this.mediaQuery.removeListener(this._mqHandler);
      }
    }
  }

  handleClickOutside = (event) => {
    if (!event.target.closest('.dropdown-wrapper')) {
      this.setState({
        showTopicsDropdown: false,
        showEventsDropdown: false,
        showShopDropdown: false,
        showResourcesDropdown: false,
      });
    }
  }

  getEvent() {
    fetch(myConstClass.BASE_URL + "event/getcourses")
      .then((response) => response.json())
      .then((response) => {
        this.setState({
          eventList: response,
        });
      });
  }

  someTrackingHandler() {
    ReactGA.event({
      category: "some category",
      action: "some action",
    });
  }

  toggleMobileMenu = () => {
    this.setState({ mobileMenuOpen: !this.state.mobileMenuOpen });
  }
  // Only one dropdown open at a time
  toggleAboutMenu = () => {
    this.setState(prev => ({
      openAboutMenu: !prev.openAboutMenu,
      openEventsMenu: false,
      openProductsMenu: false,
      openResourcesMenu: false,
      openMyAccountMenu: false,
    }));
  }

  toggleEventsMenu = () => {
    this.setState(prev => ({
      openAboutMenu: false,
      openEventsMenu: !prev.openEventsMenu,
      openProductsMenu: false,
      openResourcesMenu: false,
      openMyAccountMenu: false,
    }));
  }

  toggleProductsMenu = () => {
    this.setState(prev => ({
      openAboutMenu: false,
      openEventsMenu: false,
      openProductsMenu: !prev.openProductsMenu,
      openResourcesMenu: false,
      openMyAccountMenu: false,
    }));
  }

  toggleResourcesMenu = () => {
    this.setState(prev => ({
      openAboutMenu: false,
      openEventsMenu: false,
      openProductsMenu: false,
      openResourcesMenu: !prev.openResourcesMenu,
      openMyAccountMenu: false,
    }));
  }

  toggleMyAccountMenu = () => {
    this.setState(prev => ({
      openAboutMenu: false,
      openEventsMenu: false,
      openProductsMenu: false,
      openResourcesMenu: false,
      openMyAccountMenu: !prev.openMyAccountMenu,
    }));
  }

  toggleProductType = (type) => {
    this.setState(prev => ({
      openProductTypes: {
        ...prev.openProductTypes,
        [type]: !prev.openProductTypes[type]
      }
    }));
  }

  toggleEventType = (id) => {
    this.setState(prev => ({
      openEventTypes: {
        ...prev.openEventTypes,
        [id]: !prev.openEventTypes[id]
      }
    }));
  }

  toggleTopic = (id) => {
    this.setState(prev => ({
      openTopics: {
        ...prev.openTopics,
        [id]: !prev.openTopics[id]
      }
    }));
  }

  closeMobileMenu = () => {
    this.setState({ mobileMenuOpen: false });
  }

  handleSetLanguageNew(key) {
    return () => {
      if (this.key === "en") {
        this.key = "ma";
        localStorage.setItem("key", "ma");
        setLanguage("ma");
      } else {
        this.key = "en";
        localStorage.setItem("key", "en");
        setLanguage("en");
      }
      window.location.reload();
    };
  }

  handleCartClick() {
    const userId = localStorage.getItem("user_id");
    if (userId) {
      getCartDisplayCount();
    } else {
      updateGuestCartDisplay();
    }
  }

  checkUserLogin() {
    var user_id = "";
    user_id = localStorage.getItem("user_id");
    if (user_id !== "" && user_id !== null) {
      $("#signUpButton").hide();
      $("#logoutButton").show();
    } else {
      $("#signUpButton").show();
      $("#logoutButton").hide();
    }
  }

  getProductCartCount() {
    var user_id = localStorage.getItem("user_id");
    if (user_id && user_id !== "" && user_id !== null && parseInt(user_id) > 0) {
      // Use utility function to get cart count for display (products OR magazines OR events)
      getCartDisplayCount(user_id).then((totalcartcount) => {
        // Update all elements with lblCartCount class
        const cartCountElements = document.querySelectorAll(".lblCartCount");
        cartCountElements.forEach(element => {
          element.textContent = totalcartcount;
        });
        
        // Also update with jQuery for compatibility
        if (window.$) {
          window.$(".lblCartCount").html(totalcartcount);
        }
      }).catch(err => {
        console.log('Error getting cart count:', err);
      });
    } else {
      // For guests or no user, use guest cart data instead of blanking the count
      updateGuestCartDisplay();
    }
  }

  // getsiteinfo() {
  //   fetch(myConstClass.BASE_URL + "cms/getsitesetting")
  //     .then((response) => response.json())
  //     .then((response) => {
  //       if (response.status === true) {
  //         this.setState({
  //           settinginfo: response.data,
  //         });
  //       }
  //     });
  // }

  getUserInfo() {
    var user_id = "";
    user_id = localStorage.getItem("user_id");

    if (user_id !== "" && user_id !== null) {
      fetch(myConstClass.BASE_URL + "users/getuserprofile", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ user_id: user_id }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status === true) {
            this.setState({
              userinfo: response.data,
            });
            $("#user_first_name").html(
              this.state.userinfo.salutation + " " + this.state.userinfo.first_name
            );
            $("#user_last_name").html(this.state.userinfo.last_name);
          } else {
          }
        });
    }
  }

  // checkDiwaliIssue() {
  //   fetch(myConstClass.BASE_URL + "magazine/checkdiwaliissue")
  //     .then((response) => response.json())
  //     .then((response) => {
  //       this.setState({
  //         diwaliissueinfo: response,
  //       });
  //     });
  // }

  getProfilePictureUrl() {
    const { userinfo } = this.state;
    const userId = localStorage.getItem("user_id");
    // 1. Use profile_picture_url if present
    if (userinfo && userinfo.profile_picture_url) {
      return userinfo.profile_picture_url;
    }
    // 2. Check cached URL in localStorage
    if (userId) {
      const cachedUrl = localStorage.getItem(`profile_picture_url_${userId}`);
      if (cachedUrl && cachedUrl !== 'null') {
        return cachedUrl;
      }
    }
    // 3. Fallback to IMAGE_URL + profile_picture if present (match old header logic)
    if (userinfo && userinfo.profile_picture) {
      // myConstClass.IMAGE_URL already ends with /user/
      return myConstClass.IMAGE_URL + userinfo.profile_picture;
    }
    // 4. Default SVG icon file
    return userCircleIcon;
  }

  logout() {
    clearGuestStatesOnLogin();
    localStorage.clear();
    this.setState({ redirect: "/signin" });
  }

  handleSubmit(e) {
    e.preventDefault();
    const { subscribeinfo } = this.state;
    if (this.validatorNewsletter.allValid()) {
      fetch(myConstClass.BASE_URL + "cms/addsubscribe", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(subscribeinfo),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status === true) {
            this.setState({
              subscribeinfo: {
                first_name: "",
                last_name: "",
                email: "",
              },
            });
            toast.success(response.message);
            $("#closeNewsletter").click();
          } else {
            toast.error(response.message);
          }
        });
    } else {
      this.validatorNewsletter.showMessages();
      this.forceUpdate();
    }
  }

  onMouseEnter(id) {
    $("#" + id).css("display", "block");
  }

  onMouseLeave(id) {
    $("#" + id).css("display", "none");
  }

  onMouseProductsDiv() {
    $(".productsMenuLinks").slideDown("fast");
  }

  closeProductsDiv() {
    $(".productsMenuLinks").slideUp("fast");
  }

  onMouseEnterEventsDiv() {
    $(".eventsMenuLinks").slideDown("fast");
  }
  closeEventsDiv() {
    $(".eventsMenuLinks").slideUp("fast");
  }

  render() {
    const { settinginfo, userinfo, subscribeinfo } = this.state;
    const { t, signin } = this.props;
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />
    }

    // On small mobile widths render the existing (old) Header component
    // if (this.state.isMobile) {
    //   return <Header {...this.props} />;
    // }


    // Use translation system for logo (reactive to language)
    const logoUrl = t("home.logo");

    return (
      <div>
        {/* <Appnew /> */}
        <div className="new-header-wrapper">
          {/* Main Navigation */}
          <nav className="new-header-main-nav">
            <div className="container-fluid">
              <div className="nav-content">
                {/* Logo */}
                <Link className="new-header-logo" to="/">
                  <img
                    src={logoUrl}
                    alt="Manashakti Logo"
                    style={{ width: "auto", height: "auto", maxHeight: "73px" }}
                  />
                </Link>

                {/* Mobile Right Icons */}
                <div className="mobile-right-icons">
                  <Link to="/site-search" className="mobile-search-icon">
                    <svg className="search-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                      <path d="M480 272C480 317.9 465.1 360.3 440 394.7L566.6 521.4C579.1 533.9 579.1 554.2 566.6 566.7C554.1 579.2 533.8 579.2 521.3 566.7L394.7 440C360.3 465.1 317.9 480 272 480C157.1 480 64 386.9 64 272C64 157.1 157.1 64 272 64C386.9 64 480 157.1 480 272zM272 416C351.5 416 416 351.5 416 272C416 192.5 351.5 128 272 128C192.5 128 128 192.5 128 272C128 351.5 192.5 416 272 416z"/>
                    </svg>
                  </Link>
                  <Link to="/mycart" className="mobile-cart-icon">
                    <img src={cartImg} alt="Cart" />
                    <span className="cart-count lblCartCount">0</span>
                    <span className="mobile-cart-text">{t("home.Cart")}</span>
                  </Link>
                </div>

                {/* Desktop Navigation + Actions grouped */}
                <div className="nav-group">
                <ul className="new-header-nav-menu">
                  {/* ABOUT Dropdown */}
                  <li
                    className={`nav-item dropdown-wrapper${this.state.openAboutMenu ? ' open' : ''}`}
                    onMouseEnter={() => this.setState({ openAboutMenu: true })}
                    onMouseLeave={() => this.setState({ openAboutMenu: false })}
                  >
                    <span className="nav-link cursorDefault">{t("home.ABOUT")}</span>
                    <div className="dropdown-menu">

                      <Link className="dropdown-item" to="/about-us/6" onClick={() => { this.closeAllDropdowns(); }}>{t("home.ABOUT US")}</Link>
                      <Link className="dropdown-item" to="/about-us/1" onClick={() => { this.closeAllDropdowns(); }}>{t("home.Vission & Mission")}</Link>
                      <Link className="dropdown-item" to="/about-us/2" onClick={() => { this.closeAllDropdowns(); }}>{t("home.First Thinker")}</Link>
                      <Link className="dropdown-item" to="/about-us/8" onClick={() => { this.closeAllDropdowns(); }}>{t("home.New Way Philosopy")}</Link>
                      <Link className="dropdown-item" to="/booknow/All/0?eventType=All" onClick={() => { this.closeAllDropdowns(); }}>{t("home.Abt-Topics")}</Link>
                      <Link className="dropdown-item" to="/about-us/3" onClick={() => { this.closeAllDropdowns(); }}>{t("home.Values")}</Link>
                      <Link className="dropdown-item" to="/about-us/4" onClick={() => { this.closeAllDropdowns(); }}>{t("home.Work Areas")}</Link>
                      <Link className="dropdown-item" to="/about-us/5" onClick={() => { this.closeAllDropdowns(); }}>{t("home.Comments Of World Thinkers")}</Link>
                      <Link className="dropdown-item" to="/cycle-of-good-deeds" onClick={() => { this.closeAllDropdowns(); }}>{t("home.SOCIAL WELFARE ACTIVITIES")}</Link>
                    </div>
                  </li>
                  <li className="nav-item">
                    <Link to="/research">{t("home.RESEARCH")}</Link>
                  </li>
                  {/* Mind Tests Section */}
                  <li
                    className={`nav-item dropdown-wrapper${this.state.openMachineTestsMenu ? ' open' : ''}`}
                    onMouseEnter={() => this.setState({ openMachineTestsMenu: true })}
                    onMouseLeave={() => this.setState({ openMachineTestsMenu: false })}
                  >
                    <span className="nav-link cursorDefault">{t("home.Machine Tests")}</span>
                    <div className="dropdown-menu">
                      <Link className="dropdown-item" to="/booknow/Machine Tests/3" onClick={() => this.setState({ openMachineTestsMenu: false })}>{t("home.In-Person Tests")}</Link>
                      <Link className="dropdown-item" to="/event_details/83" onClick={() => this.setState({ openMachineTestsMenu: false })}>{t("home.Psycho-Feedback Therapy")}</Link>
                      <a className="dropdown-item" href="https://onlineselftests.manashakti.org/" target="_blank" rel="noopener noreferrer">{t("home.Online Tests")}</a>
                    </div>
                  </li>
                  <li 
                    className="nav-item dropdown"
                    onMouseLeave={(e) => {
                      const relatedTarget = e.relatedTarget;
                      const dropdownMenu = e.currentTarget.querySelector('.eventsMenuLinks');
                      if (relatedTarget && dropdownMenu && dropdownMenu.contains(relatedTarget)) {
                        return;
                      }
                      this.closeEventsDiv();
                    }}
                  >
                    <a
                      className="nav-link color--dark-brown cursorDefault"
                      id="navbarDropdownMenuLink"
                      href="#"
                      role="button"
                      onClick={(e) => e.preventDefault()}
                      onMouseEnter={() => this.onMouseEnterEventsDiv()}
                    >
                      {t("home.EVENTS")} 
                      {/* <i className="fa fa-angle-down float-right mt-2 pr-3 mr-4" id="mobile_dropdown"></i> */}
                      {/* <span className="dropdown-toggle"></span> */}
                    </a>

                    <div
                      className="dropdown-menu headerDropDownMenu eventsMenuLinks"
                      aria-labelledby="navbarDropdownMenuLink"
                      style={{ minWidth: "259px" }}
                      onMouseEnter={() => this.onMouseEnterEventsDiv()}
                      onMouseLeave={() => this.closeEventsDiv()}
                    >

                      {/* Online Courses link will be moved below Group visit */}
                      {this.state.eventList
                        .filter(event => {
                          // Remove Machine Tests from Event Info
                          const nameEn = event.event_type_en && event.event_type_en.toLowerCase();
                          const nameMr = event.event_type_mr && event.event_type_mr.toLowerCase();
                          return nameEn !== "machine tests" && nameMr !== "मशीन टेस्ट्स";
                        })
                        .map((event) => {
                          // Always use English name for URL — EventFilters matches against English names
                          const urlCategoryName = event.event_type_en;
                          // Language-specific display name for the menu link text
                          let displayCategoryName = localStorage.getItem("key") === "ma"
                            ? event.event_type_mr
                            : event.event_type_en;
                          // Map '1-Day Workshops' to 'Workshops' (EN) and Marathi equivalent if needed
                          if (localStorage.getItem("key") === "en" && displayCategoryName === "1-Day Workshops") {
                            displayCategoryName = "Workshops";
                          }
                          // Add Marathi mapping if needed, e.g. if event_type_mr === "१ दिवस कार्यशाळा" then displayCategoryName = "कार्यशाळा";
                          if (localStorage.getItem("key") === "ma" && (displayCategoryName === "१ दिवस कार्यशाळा" || displayCategoryName === "१ दिवसीय कार्यशाळा")) {
                            displayCategoryName = "कार्यशाळा";
                          }
                          const targetUrl = `/booknow/${encodeURIComponent(urlCategoryName)}/${event.event_type_id}`;
                          return (
                            <div key={event.event_type_id} style={{ position: 'relative' }}>
                              <Link
                                className="dropdown-item"
                                to={targetUrl}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.onMouseLeave.bind(this, event.event_type_id)();
                                  this.closeEventsDiv();
                                }}
                                onMouseLeave={this.onMouseLeave.bind(this, event.event_type_id)}
                                onMouseEnter={this.onMouseEnter.bind(this, event.event_type_id)}
                              >
                                {displayCategoryName}
                              </Link>
                              <div
                                onMouseLeave={this.onMouseLeave.bind(this, event.event_type_id)}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.onMouseLeave.bind(this, event.event_type_id)();
                                }}
                                onMouseEnter={this.onMouseEnter.bind(this, event.event_type_id)}
                                id={event.event_type_id}
                                className="dropdown-menu-second-lv"
                                aria-labelledby="navbarDropdownMenuLink"
                                style={{ minWidth: "300px" }}
                              >
                                {event.arr_topics.map((topic, index) => {
                                  const topicTitle = localStorage.getItem("key") === "ma"
                                    ? topic.topic_title_mr
                                    : topic.topic_title_en;
                                  // Always use English name for URL routing consistency
                                  const categoryNameInner = event.event_type_en;
                                  const targetUrlInner = `/booknow/${encodeURIComponent(categoryNameInner)}/${event.event_type_id}`;
                                  const locationState = {
                                    selectedTopic: topicTitle,
                                    topicId: topic.topic_id,
                                    eventTypeId: event.event_type_id,
                                    categoryName: categoryNameInner
                                  };
                                  return (
                                    <Link
                                      key={topic.topic_id}
                                      className="dropdown-item"
                                      to={{ pathname: targetUrlInner, state: locationState }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        this.onMouseLeave.bind(this, event.event_type_id + "" + topic.topic_id)();
                                        this.closeEventsDiv();
                                      }}
                                      onMouseLeave={this.onMouseLeave.bind(this, event.event_type_id + "" + topic.topic_id)}
                                      onMouseEnter={this.onMouseEnter.bind(this, event.event_type_id + "" + topic.topic_id)}
                                    >
                                      {topicTitle}
                                      {topic.arr_courses.length ? (
                                        <div
                                          onMouseLeave={this.onMouseLeave.bind(this, event.event_type_id + "" + topic.topic_id)}
                                          onClick={this.onMouseLeave.bind(this, event.event_type_id + "" + topic.topic_id)}
                                          onMouseEnter={this.onMouseEnter.bind(this, event.event_type_id + "" + topic.topic_id)}
                                          id={event.event_type_id + "" + topic.topic_id}
                                          className="dropdown-menu-third-lv"
                                          aria-labelledby="navbarDropdownMenuLink"
                                          style={{
                                            minWidth: "250px",
                                            top: topic.arr_courses.length < 8 ? index * 2 + "rem" : 0 + "rem",
                                          }}
                                        >
                                          <ul style={{ listStyle: "none" }}>
                                            <li>
                                              {topic.arr_courses.map((courses) => {
                                                const courseTitle = localStorage.getItem("key") === "ma"
                                                  ? courses.title_mr
                                                  : courses.title_en;
                                                const targetUrlCourse = `/event_details/${courses.event_id}`;
                                                const courseLocationState = {
                                                  selectedTopic: topicTitle,
                                                  topicId: topic.topic_id,
                                                  eventTypeId: event.event_type_id,
                                                  categoryName: categoryNameInner,
                                                  selectedEvent: courseTitle,
                                                  eventId: courses.event_id
                                                };
                                                return (
                                                  <Link
                                                    key={courses.event_id}
                                                    className="dropdown-item"
                                                    to={{ pathname: targetUrlCourse, state: courseLocationState }}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      this.onMouseLeave.bind(this, event.event_type_id + "" + topic.topic_id)();
                                                      this.closeEventsDiv();
                                                    }}
                                                  >
                                                    {courseTitle}
                                                  </Link>
                                                );
                                              })}
                                            </li>
                                          </ul>
                                        </div>
                                      ) : null}
                                    </Link>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })}
                      {/* Removed Psycho-Feedback Therapy from Event Info */}
            <Link className="dropdown-item" to="/organize-a-trip/7" onMouseLeave={this.onMouseLeave.bind(this, "organizeDiv")} onMouseEnter={this.onMouseEnter.bind(this, "organizeDiv")} onClick={() => { this.onMouseLeave.bind(this, "organizeDiv"); this.closeEventsDiv(); }}>{t("Group Visit")}</Link>

            <a
              className="dropdown-item"
              href="https://onlinecourses.manashakti.org/"
              target="_blank"
              onClick={() => this.closeEventsDiv()}
            >
              {t("home.Online Courses")}
            </a>

                    </div>
                  </li>
                  <li className="nav-item dropdown" onMouseEnter={() => this.onMouseProductsDiv()}>
                    {/* <a
                      className="nav-link  color--dark-brown"
                      href="/products"
                      onClick={(e) => e.preventDefault()}
                      id="navbarDropdownMenuLink"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      {t("home.PRODUCTS")} 
                    </a> */}
                    <Link className="nav-link  color--dark-brown" to="/products">{t("home.PRODUCTS")}</Link>
                    <div className="dropdown-menu headerDropDownMenu headerDropDownMenusForProduct productsMenuLinks" aria-labelledby="navbarDropdownMenuLink">

                      <Link
                        className="dropdown-item"
                        to="/product_type/books/1"
                        onMouseLeave={this.onMouseLeave.bind(this, "booksDiv")}
                        onMouseEnter={this.onMouseEnter.bind(this, "booksDiv")}
                        onClick={() => { this.onMouseLeave.bind(this, "booksDiv"); this.closeProductsDiv(); }}
                      >
                        {t("home.Books")}
                        <div
                          onMouseLeave={this.onMouseLeave.bind(this, "booksDiv")}
                          onClick={this.onMouseLeave.bind(this, "booksDiv")}
                          onMouseEnter={this.onMouseEnter.bind(this, "booksDiv")}
                          id="booksDiv"
                          className="dropdown-menu"
                          aria-labelledby="navbarDropdownMenuLink"
                        >
                          <ul className="dropDownMenu" style={{ listStyle: "none" }}>
                            <li>
                              <Link className="dropdown-item" to="/product_type/books/1/1">{t("home.Newly Wed Couples")}</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/product_type/books/1/2">{t("home.Pre Natal(Garbha Sanskar)")}</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/product_type/books/1/3">{t("home.Nurturing Kids")}{t("home.Birth up to 7 years")}</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/product_type/books/1/4">{t("home.Child Development & Parenting - Birth 8 to 14 years")}</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/product_type/books/1/5">{t("home.Youth Power")}</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/product_type/books/1/6">{t("home.Stress Management")}</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/product_type/books/1/7">{t("home.Health Care")}</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/product_type/books/1/8">{t("home.Meditation & Yoga")}</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/product_type/books/1/9">{t("home.Science of Spirituality")}</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/product_type/books/1/10">{t("home.Life after Death")}</Link>
                            </li>
                          </ul>
                        </div>
                      </Link>

                      {/* Replace Workshops with Kits */}
                      <Link
                        className="dropdown-item"
                        to="/product_type/kits/2"
                        onClick={this.closeMobileMenu}
                      >
                        {t("kits")}
                      </Link>

                      <Link
                        className="dropdown-item"
                        to="/product_type/CDs/3"
                        onMouseLeave={this.onMouseLeave.bind(this, "cdsDiv")}
                        onMouseEnter={this.onMouseEnter.bind(this, "cdsDiv")}
                        onClick={() => { this.onMouseLeave.bind(this, "cdsDiv"); this.closeProductsDiv(); }}
                      >
                        {t("home.CDs")}
                        <div id="cdsDiv" className="dropdown-menu" onMouseEnter={this.onMouseEnter.bind(this, "cdsDiv")} onMouseLeave={this.onMouseLeave.bind(this, "cdsDiv") } onClick={this.onMouseLeave.bind(this, "cdsDiv") }>
                          <ul className="dropDownMenu" style={{ listStyle: "none" }}>
                            <li><Link className="dropdown-item" to="/product_type/CDs/3/1">{t("home.Newly Wed Couples")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/CDs/3/2">{t("home.Pre Natal(Garbha Sanskar)")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/CDs/3/3">{t("home.Nurturing Kids")}{t("home.Birth up to 7 years")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/CDs/3/4">{t("home.Child Development & Parenting - Birth 8 to 14 years")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/CDs/3/5">{t("home.Youth Power")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/CDs/3/6">{t("home.Stress Management")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/CDs/3/7">{t("home.Health Care")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/CDs/3/8">{t("home.Meditation & Yoga")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/CDs/3/9">{t("home.Science of Spirituality")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/CDs/3/10">{t("home.Life after Death")}</Link></li>
                          </ul>
                        </div>
                      </Link>

                      <Link
                        className="dropdown-item"
                        to="/product_type/experimental/4"
                        onMouseLeave={this.onMouseLeave.bind(this, "experimentalDiv")}
                        onMouseEnter={this.onMouseEnter.bind(this, "experimentalDiv")}
                        onClick={() => { this.onMouseLeave.bind(this, "experimentalDiv"); this.closeProductsDiv(); }}
                      >
                        {t("home.Experimentals Products")}
                        <div id="experimentalDiv" className="dropdown-menu" onMouseEnter={this.onMouseEnter.bind(this, "experimentalDiv")} onMouseLeave={this.onMouseLeave.bind(this, "experimentalDiv") } onClick={this.onMouseLeave.bind(this, "experimentalDiv") }>
                          <ul className="dropDownMenu" style={{ listStyle: "none" }}>
                            <li><Link className="dropdown-item" to="/product_type/experimental/4/1">{t("home.Newly Wed Couples")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/experimental/4/2">{t("home.Pre Natal(Garbha Sanskar)")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/experimental/4/3">{t("home.Nurturing Kids")}{t("home.Birth up to 7 years")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/experimental/4/4">{t("home.Child Development & Parenting - Birth 8 to 14 years")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/experimental/4/5">{t("home.Youth Power")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/experimental/4/6">{t("home.Stress Management")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/experimental/4/7">{t("home.Health Care")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/experimental/4/8">{t("home.Meditation & Yoga")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/experimental/4/9">{t("home.Science of Spirituality")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/experimental/4/10">{t("home.Life after Death")}</Link></li>
                          </ul>
                        </div>
                      </Link>

                      <Link
                        className="dropdown-item"
                        to="/product_type/ayurvedic/5"
                        onMouseLeave={this.onMouseLeave.bind(this, "ayurvedicDiv")}
                        onMouseEnter={this.onMouseEnter.bind(this, "ayurvedicDiv")}
                        onClick={() => { this.onMouseLeave.bind(this, "ayurvedicDiv"); this.closeProductsDiv(); }}
                      >
                        {t("home.Ayurvedic")}
                        <div id="ayurvedicDiv" className="dropdown-menu" onMouseEnter={this.onMouseEnter.bind(this, "ayurvedicDiv")} onMouseLeave={this.onMouseLeave.bind(this, "ayurvedicDiv") } onClick={this.onMouseLeave.bind(this, "ayurvedicDiv") }>
                          <ul className="dropDownMenu" style={{ listStyle: "none" }}>
                            <li><Link className="dropdown-item" to="/product_type/ayurvedic/5/1">{t("home.Newly Wed Couples")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/ayurvedic/5/2">{t("home.Pre Natal(Garbha Sanskar)")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/ayurvedic/5/3">{t("home.Nurturing Kids")}{t("home.Birth up to 7 years")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/ayurvedic/5/4">{t("home.Child Development & Parenting - Birth 8 to 14 years")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/ayurvedic/5/5">{t("home.Youth Power")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/ayurvedic/5/6">{t("home.Stress Management")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/ayurvedic/5/7">{t("home.Health Care")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/ayurvedic/5/8">{t("home.Meditation & Yoga")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/ayurvedic/5/9">{t("home.Science of Spirituality")}</Link></li>
                            <li><Link className="dropdown-item" to="/product_type/ayurvedic/5/10">{t("home.Life after Death")}</Link></li>
                          </ul>
                        </div>
                      </Link>

                      <Link className="dropdown-item" to="/magazine" onClick={() => this.closeProductsDiv()}>{t("home.Magazine")}</Link>

                      <Link className="dropdown-item" to="/product_type/diwali/6" onMouseLeave={this.onMouseLeave.bind(this, "diwaliDiv")} onMouseEnter={this.onMouseEnter.bind(this, "diwaliDiv")} onClick={() => { this.onMouseLeave.bind(this, "diwaliDiv"); this.closeProductsDiv(); }}>{t("home.Diwali Issue")}</Link>

                      <Link className="dropdown-item" to="/product_type/bal-diwali/7" onMouseLeave={this.onMouseLeave.bind(this, "baldiwaliDiv")} onMouseEnter={this.onMouseEnter.bind(this, "baldiwaliDiv")} onClick={() => { this.onMouseLeave.bind(this, "baldiwaliDiv"); this.closeProductsDiv(); }}>{t("home.Bal Diwali Issue")}</Link>
                    </div>
                  </li>
                  <li className="nav-item">
                      <Link to="/event-calendar">
                       <i className="fa fa-calendar" style={{ color: "#a6acaf", marginRight: "6px" }}></i>
                        {t("home.Events Calendar")}
                      </Link>
                  </li>
                  {/* RESOURCES Dropdown */}
                  <li
                    className={`nav-item dropdown-wrapper${this.state.openResourcesMenu ? ' open' : ''}`}
                    onMouseEnter={() => this.setState({ openResourcesMenu: true })}
                    onMouseLeave={() => this.setState({ openResourcesMenu: false })}
                  >
                    <span className="nav-link cursorDefault">{t("home.RESOURCES")}</span>
                    <div className="dropdown-menu">

                      <Link className="dropdown-item" to="/download" onClick={() => { this.closeAllDropdowns(); }}>{t("home.Free Study Resources")}</Link>
                      <Link className="dropdown-item" to="/faqs" onClick={() => { this.closeAllDropdowns(); }}>{t("home.FAQs")}</Link>
                      <Link className="dropdown-item" to="/news/1" onClick={() => { this.closeAllDropdowns(); }}>{t("home.News")}</Link>
                      <Link className="dropdown-item" to="/photo-gallery" onClick={() => { this.closeAllDropdowns(); }}>{t("home.Gallery")}</Link>
                      <Link className="dropdown-item" to="/e-shopping-help" onClick={() => { this.closeAllDropdowns(); }}>{t("e_shopping_help")}</Link>
                      <Link className="dropdown-item" to="/site-map" onClick={() => { this.closeAllDropdowns(); }}>{t("home.Site Map")}</Link>
                      <Link className="dropdown-item" to="/feedback" onClick={() => { this.closeAllDropdowns(); }}>{t("home.Feedback")}</Link>
                    </div>
                  </li>
                  <li>
                    <Link to="/contact-us" className="nav-item main-nav-contact-link">
                    {t("home.contact_us_small")}
                  </Link>
                  </li>
                </ul>

                {/* Right Side Actions */}
                <div className="new-header-actions">
                  <div 
                    className="main-nav-language-toggle" 
                    onClick={this.handleSetLanguageNew(this.key)}
                  >
                    {t("home.language")}
                  </div>

                  <Link to="/site-search" className="action-icon search-icon" aria-label="Search">
                    <svg className="search-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" aria-hidden="true" focusable="false">
                      <path d="M480 272C480 317.9 465.1 360.3 440 394.7L566.6 521.4C579.1 533.9 579.1 554.2 566.6 566.7C554.1 579.2 533.8 579.2 521.3 566.7L394.7 440C360.3 465.1 317.9 480 272 480C157.1 480 64 386.9 64 272C64 157.1 157.1 64 272 64C386.9 64 480 157.1 480 272zM272 416C351.5 416 416 351.5 416 272C416 192.5 351.5 128 272 128C192.5 128 128 192.5 128 272C128 351.5 192.5 416 272 416z"/>
                    </svg>
                  </Link>
                  
                  <Link to="/mycart" className="action-icon cart-icon">
                    <img src={cartImg} alt="Cart" className="cart-img" />
                    <span className="cart-title">{t('home.Cart')}</span>
                    <span id="lblCartCount" className="cart-count lblCartCount">0</span>
                  </Link>

                  <div id="signUpButton" className="auth-buttons">
                    <Link 
                      className="login-register-btn" 
                      to="/signin"
                      onClick={() => {
                        if (window.location.pathname !== '/signin') {
                          localStorage.setItem('redirect_after_login', window.location.pathname);
                        }
                      }}
                    >
                      {t("home.Login")} / {t("home.Register")}
                    </Link>
                  </div>

                  <div id="logoutButton" className="user-profile-section" style={{display: 'none'}}>
                    <div
                      className={`dropdown-wrapper${this.state.openProfileMenu ? ' open' : ''}`}
                      onMouseEnter={() => this.setState({ openProfileMenu: true })}
                      onMouseLeave={() => this.setState({ openProfileMenu: false })}
                    >
                      <img
                        className="profile-img"
                        src={this.getProfilePictureUrl()}
                        alt="Profile"
                        onError={e => { e.target.onerror = null; e.target.src = userCircleIcon; }}
                      />
                      <span className="user-name">
                        <span id="user_first_name"></span> <span id="user_last_name"></span>
                      </span>
                      <div className="dropdown-menu profile-dropdown">
                        <div className="dropdown-header">{t("home.My Account")}</div>
                        <Link className="dropdown-item" to="/profile" onClick={() => this.setState({ openProfileMenu: false })}>
                          {t("home.Profile")}
                        </Link>
                        <Link className="dropdown-item" to="/change-password" onClick={() => this.setState({ openProfileMenu: false })}>
                          {t("home.Change Password")}
                        </Link>
                        <Link className="dropdown-item" to="/my-interactions" onClick={() => this.setState({ openProfileMenu: false })}>
                          {t("home.My Interactions")}
                        </Link>
                        <Link className="dropdown-item" to="/participants" onClick={() => this.setState({ openProfileMenu: false })}>
                          {t("home.Master List of Participants")}
                        </Link>
                        <Link className="dropdown-item" to="/order-history" onClick={() => this.setState({ openProfileMenu: false })}>
                          {t("home.Order History")}
                        </Link>
                        <Link className="dropdown-item" to="/donation-contribution" onClick={() => this.setState({ openProfileMenu: false })}>
                          {t("home.donation_contribution")}
                        </Link>
                        <Link className="dropdown-item" to="/logout" onClick={() => this.setState({ openProfileMenu: false })}>
                          {t("home.Sign Out")}
                        </Link>
                      </div>
                    </div>
                    </div>
                  </div>

                  {/* Mobile Menu Toggle */}
                  <button className="mobile-menu-toggle" onClick={this.toggleMobileMenu}>
                    <span className="navbar-toggler-icon"></span>
                  </button>
                </div>
              </div>
            </div>
          </nav>  

          {/* Mobile Menu */}
          <div className={`mobile-menu ${this.state.mobileMenuOpen ? 'active' : ''}`}>
            <div className="mobile-menu-header">
              <span className="welcome-text">
                <img
                  className="rounded-circle"
                  height="30"
                  width="30"
                  src={this.getProfilePictureUrl()}
                  alt="Profile Image"
                  style={{ marginRight: "8px" }}
                  onError={e => { e.target.onerror = null; e.target.src = userCircleIcon; }}
                />
                Welcome {localStorage.getItem("first_name") || 'Guest'}
              </span>
              <button className="close-btn" onClick={this.closeMobileMenu}>
                &times;
              </button>
            </div>
            <div className="mobile-menu-content">
                <div className="mobile-parent">
                  <a
                        className="dropdown-item language-btn main-nav-language-toggle"
                        onClick={this.handleSetLanguageNew(this.key)}
                        style={{ color: "#942323",
                                border: "1.5px  solid #E8C35B",
                                borderRadius: "4px",
                                padding: "4px 10px",
                                fontSize: "14px",
                                fontWeight: "500",
                                textAlign: "center",
                                width: "fit-content",
                                margin: "5px auto"
                              }}
                      >
                        {t("home.language")}
                  </a>
                </div>

              {/* ABOUT US */}
              <div className="mobile-parent">
                <div className="mobile-parent-header" onClick={this.toggleAboutMenu}>
                  {t("home.ABOUT")}
                  <span className="arrow">{this.state.openAboutMenu ? "−" : "+"}</span>
                </div>

                {this.state.openAboutMenu && (
                  <div className="mobile-submenu">
                    <Link to="/about-us/6" onClick={this.closeMobileMenu}>{t("home.ABOUT US")}</Link>
                    <Link to="/about-us/1" onClick={this.closeMobileMenu}>{t("home.Vission & Mission")}</Link>
                    <Link to="/about-us/2" onClick={this.closeMobileMenu}>{t("home.First Thinker")}</Link>
                    <Link to="/about-us/8" onClick={this.closeMobileMenu}>{t("home.New Way Philosopy")}</Link>
                    <Link to="/about-us/3" onClick={this.closeMobileMenu}>{t("home.Values")}</Link>
                    <Link to="/about-us/4" onClick={this.closeMobileMenu}>{t("home.Work Areas")}</Link>
                    <Link to="/about-us/5" onClick={this.closeMobileMenu}>{t("home.Comments Of World Thinkers")}</Link>
                    <Link to="/cycle-of-good-deeds" onClick={this.closeMobileMenu}>{t("home.SOCIAL WELFARE ACTIVITIES")}</Link>
                  </div>
                )}
              </div>

              {/* RESEARCH */}
              <Link to="/research" onClick={this.closeMobileMenu}>
              {t("home.RESEARCH")}
              </Link>


              {/* Mind Tests Section (Mobile) */}
              <div className="mobile-parent">
                <div className="mobile-parent-header" onClick={this.toggleResourcesMenu}>
                  {t("home.Machine Tests")}
                  <span className="arrow">{this.state.openResourcesMenu ? "−" : "+"}</span>
                </div>
                {this.state.openResourcesMenu && (
                  <div className="mobile-submenu">
                    <Link to="/booknow/Machine Tests/3" onClick={this.closeMobileMenu}>{t("home.In-Person Tests")}</Link>
                    <Link to="/event_details/83" onClick={this.closeMobileMenu}>{t("home.Psycho-Feedback Therapy")}</Link>
                    <a href="https://onlineselftests.manashakti.org/" target="_blank" rel="noopener noreferrer">{t("home.Online Tests")}</a>
                  </div>
                )}
              </div>

              {/* EVENTS */}
              <div className="mobile-parent">

                <div className="mobile-parent-header" onClick={this.toggleEventsMenu}>
                  {t("home.EVENTS")}
                  <span className="arrow">{this.state.openEventsMenu ? "−" : "+"}</span>
                </div>

                {this.state.openEventsMenu && (

                  <div className="mobile-submenu">
                    {this.state.eventList
                      .filter(event => {
                        // Remove Machine Tests from Event Info (mobile)
                        const nameEn = event.event_type_en && event.event_type_en.toLowerCase();
                        const nameMr = event.event_type_mr && event.event_type_mr.toLowerCase();
                        return nameEn !== "machine tests" && nameMr !== "मशीन टेस्ट्स";
                      })
                      .map((event) => {
                        // Always use English name for URL — EventFilters matches against English names
                        const urlCategoryName = event.event_type_en;
                        // Language-specific display name for the menu link text
                        let displayCategoryName = localStorage.getItem("key") === "ma"
                          ? event.event_type_mr
                          : event.event_type_en;
                        // Map '1-Day Workshops' to 'Workshops' (EN) and Marathi equivalent if needed
                        if (localStorage.getItem("key") === "en" && displayCategoryName === "1-Day Workshops") {
                          displayCategoryName = "Workshops";
                        }
                        if (localStorage.getItem("key") === "ma" && (displayCategoryName === "१ दिवस कार्यशाळा" || displayCategoryName === "१ दिवसीय कार्यशाळा")) {
                          displayCategoryName = "कार्यशाळा";
                        }
                        return (
                          <div key={event.event_type_id} className="mobile-parent">
                            <div className="mobile-parent-header">
                              {/* EVENT TYPE LINK */}
                              <Link
                                className="mobile-menu-link"
                                to={`/booknow/${encodeURIComponent(urlCategoryName)}/${event.event_type_id}`}
                                onClick={this.closeMobileMenu}
                              >
                                {displayCategoryName}
                              </Link>
                              {/* TOGGLE */}
                              <span
                                className="arrow"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.toggleEventType(event.event_type_id);
                                }}
                              >
                                {this.state.openEventTypes[event.event_type_id] ? "−" : "+"}
                              </span>

                            </div>

                            {this.state.openEventTypes[event.event_type_id] && (

                              <div className="mobile-submenu">

                                {event.arr_topics.map((topic) => {

                                  const topicTitle =
                                    localStorage.getItem("key") === "ma"
                                      ? topic.topic_title_mr
                                      : topic.topic_title_en;

                                  return (

                                    <div key={topic.topic_id} className="mobile-parent">

                                      <div className="mobile-parent-header">

                                        {/* TOPIC LINK */}
                                        <Link
                                          className="mobile-menu-link"
                                          to={{
                                            pathname: `/booknow/${encodeURIComponent(urlCategoryName)}/${event.event_type_id}`,
                                            state: {
                                              selectedTopic: topicTitle,
                                              topicId: topic.topic_id,
                                              eventTypeId: event.event_type_id,
                                              categoryName: urlCategoryName
                                            }
                                          }}
                                          onClick={this.closeMobileMenu}
                                        >
                                          {topicTitle}
                                        </Link>

                                        {/* TOGGLE */}
                                        <span
                                          className="arrow"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            this.toggleTopic(topic.topic_id);
                                          }}
                                        >
                                          {this.state.openTopics[topic.topic_id] ? "−" : "+"}
                                        </span>

                                      </div>

                                      {this.state.openTopics[topic.topic_id] && (

                                        <div className="mobile-submenu">

                                          {topic.arr_courses.map((course) => {

                                            const courseTitle =
                                              localStorage.getItem("key") === "ma"
                                                ? course.title_mr
                                                : course.title_en;

                                            return (
                                              <Link
                                                key={course.event_id}
                                                to={`/event_details/${course.event_id}`}
                                                onClick={this.closeMobileMenu}
                                              >
                                                {courseTitle}
                                              </Link>
                                            );
                                          })}

                                        </div>

                                      )}

                                    </div>

                                  );

                                })}

                              </div>

                            )}

                          </div>

                        );

                      })}

                    {/* Removed Psycho-Feedback Therapy from Event Info (mobile) */}


                    <Link
                      className="dropdown-item"
                      to="/organize-a-trip/7"
                      onClick={this.closeMobileMenu}
                    >
                      {t("Group Visit")}
                    </Link>
                    <hr className="mobile-menu-separator" style={{ margin: '8px 0' }} />
                    <a
                      className="dropdown-item"
                      href="https://onlinecourses.manashakti.org/"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={this.closeMobileMenu}
                    >
                      {t("home.Online Courses")}
                    </a>
                  </div>

                )}

              </div>

              {/* PRODUCTS */}
              <div className="mobile-parent">

                <div className="mobile-parent-header" onClick={this.toggleProductsMenu}>
                  {t("home.PRODUCTS")}
                  <span className="arrow">{this.state.openProductsMenu ? "−" : "+"}</span>
                </div>

                {this.state.openProductsMenu && (
                <div className="mobile-submenu">


                {/* BOOKS */}
                <div className="mobile-parent">

                  <div className="mobile-parent-header">

                    <Link
                      className="mobile-menu-link"
                      to="/product_type/books/1"
                      onClick={this.closeMobileMenu}
                    >
                      {t("home.Books")}
                    </Link>

                    <span
                      className="arrow"
                      onClick={(e)=>{
                        e.stopPropagation();
                        this.toggleProductType("books");
                      }}
                    >
                      {this.state.openProductTypes["books"] ? "−" : "+"}
                    </span>

                  </div>

                  {this.state.openProductTypes["books"] && (
                    <div className="mobile-submenu">
                      <Link to="/product_type/books/1/1" onClick={this.closeMobileMenu}>{t("home.Newly Wed Couples")}</Link>
                      <Link to="/product_type/books/1/2" onClick={this.closeMobileMenu}>{t("home.Pre Natal(Garbha Sanskar)")}</Link>
                      <Link to="/product_type/books/1/3" onClick={this.closeMobileMenu}>{t("home.Nurturing Kids")}</Link>
                      <Link to="/product_type/books/1/4" onClick={this.closeMobileMenu}>{t("home.Child Development & Parenting - Birth 8 to 14 years")}</Link>
                      <Link to="/product_type/books/1/5" onClick={this.closeMobileMenu}>{t("home.Youth Power")}</Link>
                      <Link to="/product_type/books/1/6" onClick={this.closeMobileMenu}>{t("home.Stress Management")}</Link>
                      <Link to="/product_type/books/1/7" onClick={this.closeMobileMenu}>{t("home.Health Care")}</Link>
                      <Link to="/product_type/books/1/8" onClick={this.closeMobileMenu}>{t("home.Meditation & Yoga")}</Link>
                      <Link to="/product_type/books/1/9" onClick={this.closeMobileMenu}>{t("home.Science of Spirituality")}</Link>
                      <Link to="/product_type/books/1/10" onClick={this.closeMobileMenu}>{t("home.Life after Death")}</Link>
                    </div>
                  )}

                </div>


                {/* KITS */}
                <div className="mobile-parent">

                  <div className="mobile-parent-header">

                    <Link
                      className="mobile-menu-link"
                      to="/product_type/kits/2"
                      onClick={this.closeMobileMenu}
                    >
                      {t("home.Kits")}
                    </Link>

                    <span
                      className="arrow"
                      onClick={(e)=>{
                        e.stopPropagation();
                        this.toggleProductType("kits");
                      }}
                    >
                      {this.state.openProductTypes["kits"] ? "−" : "+"}
                    </span>

                  </div>

                  {this.state.openProductTypes["kits"] && (
                    <div className="mobile-submenu">
                      <Link to="/product_type/kits/2/1" onClick={this.closeMobileMenu}>{t("home.Newly Wed Couples")}</Link>
                      <Link to="/product_type/kits/2/2" onClick={this.closeMobileMenu}>{t("home.Pre Natal(Garbha Sanskar)")}</Link>
                      <Link to="/product_type/kits/2/3" onClick={this.closeMobileMenu}>{t("home.Nurturing Kids")}</Link>
                      <Link to="/product_type/kits/2/4" onClick={this.closeMobileMenu}>{t("home.Child Development & Parenting - Birth 8 to 14 years")}</Link>
                      <Link to="/product_type/kits/2/5" onClick={this.closeMobileMenu}>{t("home.Youth Power")}</Link>
                      <Link to="/product_type/kits/2/6" onClick={this.closeMobileMenu}>{t("home.Stress Management")}</Link>
                      <Link to="/product_type/kits/2/7" onClick={this.closeMobileMenu}>{t("home.Health Care")}</Link>
                      <Link to="/product_type/kits/2/8" onClick={this.closeMobileMenu}>{t("home.Meditation & Yoga")}</Link>
                      <Link to="/product_type/kits/2/9" onClick={this.closeMobileMenu}>{t("home.Science of Spirituality")}</Link>
                      <Link to="/product_type/kits/2/10" onClick={this.closeMobileMenu}>{t("home.Life after Death")}</Link>
                    </div>
                  )}

                </div>


                {/* CDS */}
                <div className="mobile-parent">

                  <div className="mobile-parent-header">

                    <Link
                      className="mobile-menu-link"
                      to="/product_type/CDs/3"
                      onClick={this.closeMobileMenu}
                    >
                      {t("home.CDs")}
                    </Link>

                    <span
                      className="arrow"
                      onClick={(e)=>{
                        e.stopPropagation();
                        this.toggleProductType("cds");
                      }}
                    >
                      {this.state.openProductTypes["cds"] ? "−" : "+"}
                    </span>

                  </div>

                  {this.state.openProductTypes["cds"] && (
                    <div className="mobile-submenu">
                      <Link to="/product_type/CDs/3/1" onClick={this.closeMobileMenu}>{t("home.Newly Wed Couples")}</Link>
                      <Link to="/product_type/CDs/3/2" onClick={this.closeMobileMenu}>{t("home.Pre Natal(Garbha Sanskar)")}</Link>
                      <Link to="/product_type/CDs/3/3" onClick={this.closeMobileMenu}>{t("home.Nurturing Kids")}</Link>
                      <Link to="/product_type/CDs/3/4" onClick={this.closeMobileMenu}>{t("home.Child Development & Parenting - Birth 8 to 14 years")}</Link>
                      <Link to="/product_type/CDs/3/5" onClick={this.closeMobileMenu}>{t("home.Youth Power")}</Link>
                      <Link to="/product_type/CDs/3/6" onClick={this.closeMobileMenu}>{t("home.Stress Management")}</Link>
                      <Link to="/product_type/CDs/3/7" onClick={this.closeMobileMenu}>{t("home.Health Care")}</Link>
                      <Link to="/product_type/CDs/3/8" onClick={this.closeMobileMenu}>{t("home.Meditation & Yoga")}</Link>
                      <Link to="/product_type/CDs/3/9" onClick={this.closeMobileMenu}>{t("home.Science of Spirituality")}</Link>
                      <Link to="/product_type/CDs/3/10" onClick={this.closeMobileMenu}>{t("home.Life after Death")}</Link>
                    </div>
                  )}

                </div>


                {/* EXPERIMENTAL */}
                <div className="mobile-parent">

                  <div className="mobile-parent-header">

                    <Link
                      className="mobile-menu-link"
                      to="/product_type/experimental/4"
                      onClick={this.closeMobileMenu}
                    >
                      {t("home.Experimentals Products")}
                    </Link>

                    <span
                      className="arrow"
                      onClick={(e)=>{
                        e.stopPropagation();
                        this.toggleProductType("experimental");
                      }}
                    >
                      {this.state.openProductTypes["experimental"] ? "−" : "+"}
                    </span>

                  </div>

                  {this.state.openProductTypes["experimental"] && (
                    <div className="mobile-submenu">
                      <Link to="/product_type/experimental/4/1" onClick={this.closeMobileMenu}>{t("home.Newly Wed Couples")}</Link>
                      <Link to="/product_type/experimental/4/2" onClick={this.closeMobileMenu}>{t("home.Pre Natal(Garbha Sanskar)")}</Link>
                      <Link to="/product_type/experimental/4/3" onClick={this.closeMobileMenu}>{t("home.Nurturing Kids")}</Link>
                      <Link to="/product_type/experimental/4/4" onClick={this.closeMobileMenu}>{t("home.Child Development & Parenting - Birth 8 to 14 years")}</Link>
                      <Link to="/product_type/experimental/4/5" onClick={this.closeMobileMenu}>{t("home.Youth Power")}</Link>
                      <Link to="/product_type/experimental/4/6" onClick={this.closeMobileMenu}>{t("home.Stress Management")}</Link>
                      <Link to="/product_type/experimental/4/7" onClick={this.closeMobileMenu}>{t("home.Health Care")}</Link>
                      <Link to="/product_type/experimental/4/8" onClick={this.closeMobileMenu}>{t("home.Meditation & Yoga")}</Link>
                      <Link to="/product_type/experimental/4/9" onClick={this.closeMobileMenu}>{t("home.Science of Spirituality")}</Link>
                      <Link to="/product_type/experimental/4/10" onClick={this.closeMobileMenu}>{t("home.Life after Death")}</Link>
                    </div>
                  )}

                </div>


                {/* AYURVEDIC */}
                <div className="mobile-parent">

                  <div className="mobile-parent-header">

                    <Link
                      className="mobile-menu-link"
                      to="/product_type/ayurvedic/5"
                      onClick={this.closeMobileMenu}
                    >
                      {t("home.Ayurvedic")}
                    </Link>

                    <span
                      className="arrow"
                      onClick={(e)=>{
                        e.stopPropagation();
                        this.toggleProductType("ayurvedic");
                      }}
                    >
                      {this.state.openProductTypes["ayurvedic"] ? "−" : "+"}
                    </span>

                  </div>

                  {this.state.openProductTypes["ayurvedic"] && (
                    <div className="mobile-submenu">
                      <Link to="/product_type/ayurvedic/5/1" onClick={this.closeMobileMenu}>{t("home.Newly Wed Couples")}</Link>
                      <Link to="/product_type/ayurvedic/5/2" onClick={this.closeMobileMenu}>{t("home.Pre Natal(Garbha Sanskar)")}</Link>
                      <Link to="/product_type/ayurvedic/5/3" onClick={this.closeMobileMenu}>{t("home.Nurturing Kids")}</Link>
                      <Link to="/product_type/ayurvedic/5/4" onClick={this.closeMobileMenu}>{t("home.Child Development & Parenting - Birth 8 to 14 years")}</Link>
                      <Link to="/product_type/ayurvedic/5/5" onClick={this.closeMobileMenu}>{t("home.Youth Power")}</Link>
                      <Link to="/product_type/ayurvedic/5/6" onClick={this.closeMobileMenu}>{t("home.Stress Management")}</Link>
                      <Link to="/product_type/ayurvedic/5/7" onClick={this.closeMobileMenu}>{t("home.Health Care")}</Link>
                      <Link to="/product_type/ayurvedic/5/8" onClick={this.closeMobileMenu}>{t("home.Meditation & Yoga")}</Link>
                      <Link to="/product_type/ayurvedic/5/9" onClick={this.closeMobileMenu}>{t("home.Science of Spirituality")}</Link>
                      <Link to="/product_type/ayurvedic/5/10" onClick={this.closeMobileMenu}>{t("home.Life after Death")}</Link>
                    </div>
                  )}

                </div>


                <Link to="/magazine" onClick={this.closeMobileMenu}>{t("home.Magazine")}</Link>
                <Link to="/product_type/diwali/6" onClick={this.closeMobileMenu}>{t("home.Diwali Issue")}</Link>
                <Link to="/product_type/bal-diwali/7" onClick={this.closeMobileMenu}>{t("home.Bal Diwali Issue")}</Link>

                </div>
                )}
              </div>
              
              {/* EVENT CALENDAR */}
              <Link to="/event-calendar" onClick={this.closeMobileMenu}>
              {t("home.Events Calendar")}
              </Link>

              {/* MORE */}
              <div className="mobile-parent">
                <div className="mobile-parent-header" onClick={this.toggleResourcesMenu}>
                  {t("home.RESOURCES")}
                  <span className="arrow">{this.state.openResourcesMenu ? "−" : "+"}</span>
                </div>
                {this.state.openResourcesMenu && (
                <div className="mobile-submenu">
                  <Link className="dropdown-item" to="/download" onClick={this.closeMobileMenu}>{t("home.Free Study Resources")}</Link>
                  <Link className="dropdown-item" to="/faqs" onClick={this.closeMobileMenu}>{t("home.FAQs")}</Link>
                  <Link className="dropdown-item" to="/news/1" onClick={this.closeMobileMenu}>{t("home.News")}</Link>
                  <Link className="dropdown-item" to="/photo-gallery" onClick={this.closeMobileMenu}>{t("home.Gallery")}</Link>
                  <Link className="dropdown-item" to="/e-shopping-help" onClick={this.closeMobileMenu}>{t("e_shopping_help")}</Link>
                  <Link className="dropdown-item" to="/site-map" onClick={this.closeMobileMenu}>{t("home.Site Map")}</Link>
                  <Link className="dropdown-item" to="/feedback" onClick={this.closeMobileMenu}>{t("home.Feedback")}</Link>
                </div>
                )}
              </div>

              {/* CONTACT */}
              <Link to="/contact-us" onClick={this.closeMobileMenu}>
              {t("home.contact_us_small")}
              </Link>

              {localStorage.getItem("user_id")
                ? (
                  <div className="nav-item mobile-parent">
                    <div className="mobile-parent-header" onClick={this.toggleMyAccountMenu}>
                      {t("home.My Account")}
                      <span className="arrow">
                        {this.state.openMyAccountMenu ? "−" : "+"}
                      </span>
                    </div>
                    {this.state.openMyAccountMenu && (
                      <div className="mobile-submenu">
                        <Link className="dropdown-item profileMenuDiv" to="/profile">
                          {t("home.Profile")}
                        </Link>
                        <Link className="dropdown-item profileMenuDiv" to="/change-password">
                          {t("home.Change Password")}
                        </Link>
                        <Link className="dropdown-item profileMenuDiv" to="/my-interactions">
                          {t("home.My Interactions")}
                        </Link>
                        <Link className="dropdown-item profileMenuDiv" to="/participants">
                          {t("home.Master List of Participants")}
                        </Link>
                        <Link className="dropdown-item profileMenuDiv" to="/order-history">
                          {t("home.Order History")}
                        </Link>
                        <Link className="dropdown-item donationContribution" to="/donation-contribution">
                          {t("home.donation_contribution")}
                        </Link>
                        <Link className="dropdown-item profileMenuDiv" to="/logout">
                          {t("home.Sign Out")}
                        </Link>
                      </div>
                    )}
                  </div>
                )
                : (
                  <div className="mobile-submenu" style={{ padding: "10px 0" }}>
                    <Link
                      className="login-register-btn dropdown-item"
                      to="/signin"
                      onClick={() => {
                        if (window.location.pathname !== '/signin') {
                          localStorage.setItem('redirect_after_login', window.location.pathname);
                        }
                        this.closeMobileMenu();
                      }}
                      style={{ color: "#942323", fontWeight: 500, textAlign: "center" }}
                    >
                      {t("home.Login")} / {t("home.Register")}
                    </Link>
                  </div>
                )}
              </div>
               {/* <div className="mobile-submenu">
                  <a
                        className="dropdown-item language-btn main-nav-language-toggle"
                        onClick={this.handleSetLanguageNew(this.key)}
                        style={{ color: "#942323",
                                border: "1.5px  solid #E8C35B",
                                borderRadius: "4px",
                                padding: "4px 10px",
                                fontSize: "14px",
                                fontWeight: "500",
                                textAlign: "center",
                                width: "fit-content",
                              }}
                      >
                        {t("home.language")}
                  </a>
                </div> */}
          </div>

          {/* Newsletter Modal */}
          <div
            className="modal fade"
            id="newsletterModal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg" role="document">
              <div className="modal-content bg-light" style={{ overflow: "auto" }}>
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    {t("home.Newsletter")}
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    id="closeNewsletter"
                  >
                    <i className="far fa-times-circle"></i>
                  </button>
                </div>
                <Form onSubmit={this.handleSubmit} method="post" encType="multipart/form-data" className="form-horizontal">
                  <div className="modal-body">
                    <div className="row">
                      <div className="form-group col col-md-4">
                        <label className="color-black font-weight-bolder">
                          {t("home.Name")} <span className="color-red">*</span>
                        </label>
                        <input
                          value={subscribeinfo.first_name}
                          onChange={(e) => {
                            this.setState({
                              subscribeinfo: { ...subscribeinfo, first_name: e.target.value },
                            });
                          }}
                          onBlur={() => this.validatorNewsletter.showMessageFor("first_name")}
                          type="text"
                          className="form-control"
                          placeholder={t("home.Enter First Name")}
                        />
                        {this.validatorNewsletter.message("first_name", subscribeinfo.first_name, "required")}
                      </div>
                      <div className="form-group col col-md-4">
                        <label className="color-black font-weight-bolder">
                          {t("home.Last Name")} <span className="color-red">*</span>
                        </label>
                        <input
                          value={subscribeinfo.last_name}
                          onBlur={() => this.validatorNewsletter.showMessageFor("last_name")}
                          onChange={(e) => {
                            this.setState({
                              subscribeinfo: { ...subscribeinfo, last_name: e.target.value },
                            });
                          }}
                          type="text"
                          className="form-control"
                          placeholder={t("home.Enter Last Name")}
                        />
                        {this.validatorNewsletter.message("last_name", subscribeinfo.last_name, "required")}
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col col-md-4">
                        <label className="color-black font-weight-bolder">
                          {t("home.Email")} <span className="color-red">*</span>
                        </label>
                        <input
                          value={subscribeinfo.email}
                          onChange={(e) => {
                            this.setState({
                              subscribeinfo: { ...subscribeinfo, email: e.target.value },
                            });
                          }}
                          type="text"
                          className="form-control"
                          placeholder={t("home.Email")}
                        />
                        {this.validatorNewsletter.message("email", subscribeinfo.email, "required")}
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <span data-dismiss="modal" aria-label="Close" style={{ cursor: "pointer" }}>
                      {t("home.Cancel")}
                    </span>
                    <button type="submit" className="btn btn-outline-brown bg-white btn-sm pl-4 pr-4">
                      {t("home.Save")}
                    </button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
         {/* ✅ LOADER BELOW NAV */}
          <div className="header-progress-wrapper">
            <ProgressBarProvider 
              isActive={this.state.loading}
              color="#9d0b0e"
            />
          </div>
      </div>
    );
  }
}

NewHeader.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withRouter(translate(NewHeader));
